// extracted by mini-css-extract-plugin
export var boxItems = "_ba-1";
export var boxItemsLg = "_ba-2";
export var button = "_ba-7";
export var buttonHoverless = "_ba-9";
export var buttonLg = "_ba-8";
export var filterGroupBox = "_ba-0";
export var icon = "_ba-3";
export var iconSecondary = "_ba-6";
export var iconWrapper = "_ba-4";
export var iconWrapperLg = "_ba-5";
export var truncatedLabel = "_ba-a";